import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=741d169c&scoped=true"
import script from "./Body.vue?vue&type=script&lang=ts"
export * from "./Body.vue?vue&type=script&lang=ts"
import style0 from "./Body.vue?vue&type=style&index=0&id=741d169c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d169c",
  null
  
)

export default component.exports